import Vue from 'vue'

const units = {
  // Weight
  TON: { base: 'TON', actual: 'TON', multiplier: 1, symbol: 'ton' },
  G: { base: 'TON', actual: 'G', multiplier: 0.00000, symbol: 'g' },
  KG: { base: 'TON', actual: 'KG', multiplier: 0.001, symbol: 'kg' },
  TON_US: { base: 'TON', actual: 'TON_US', multiplier: 0.9071847, symbol: 'ton (US)' },
  TON_UK: { base: 'TON', actual: 'TON_UK', multiplier: 1.016047, symbol: 'ton (UK)' },
  LB: { base: 'TON', actual: 'LB', multiplier: 0.0004535924, symbol: 'lbs' },
  
  // Size
  M: { base: 'M', actual: 'M', multiplier: 1, symbol: 'm' },
  MI: { base: 'M', actual: 'MI', multiplier: 1609.34, symbol: 'mi' },
  CM: { base: 'M', actual: 'CM', multiplier: 0.01, symbol: 'cm' },
  DM: { base: 'M', actual: 'DM', multiplier: 0.1, symbol: 'dm' },
  IN: { base: 'M', actual: 'IN', multiplier: 0.0254, symbol: 'in' },
  FT: { base: 'M', actual: 'FT', multiplier: 0.3048, symbol: 'ft' },
  YD: { base: 'M', actual: 'YD', multiplier: 0.9144, symbol: 'yd' },
  KM: { base: 'M', actual: 'KM', multiplier: 1000, symbol: 'km' },
  
  // Volume
  M3: { base: 'M3', actual: 'M3', multiplier: 1, symbol: 'm³' },
  CC: { base: 'M3', actual: 'CC', multiplier: 0.000001, symbol: 'cc' },
  DM3: { base: 'M3', actual: 'DM3', multiplier: 0.001, symbol: 'dm³' },
  L: { base: 'M3', actual: 'L', multiplier: 0.001, symbol: 'l' },
  HL: { base: 'M3', actual: 'HL', multiplier: 0.1, symbol: 'hl' },
  IN3: { base: 'M3', actual: 'IN3', multiplier: 0.00001638706, symbol: 'in³' },
  FT3: { base: 'M3', actual: 'FT3', multiplier: 0.02831685, symbol: 'ft³' },
  YD3: { base: 'M3', actual: 'YD3', multiplier: 0.7645549, symbol: 'yd³' },
  GAL: { base: 'M3', actual: 'GAL', multiplier: 0.004546099, symbol: 'gal' }
}

function numberFilter (input, fromUnitKey, toUnitKey, options) {
  const number = Number(input)
  
  if (Number.isNaN(number)) {
    console.error(`${input} is not a valid number.`)
    return input
  }
  
  const fromUnit = units[fromUnitKey]
  const toUnit = units[toUnitKey]
  
  if (fromUnit === undefined) {
    console.error(`${fromUnitKey} is not a valid unit.`)
    return input
  }
  
  if (toUnit === undefined) {
    console.error(`${toUnitKey} is not a valid unit.`)
    return input
  }
  
  if (toUnit.base !== fromUnit.base) {
    console.error(`Incompatible units; cannot convert from ${fromUnitKey} to ${toUnitKey}`)
    return input
  }
  
  const navigatorLanguage = window.navigator.language
  options = Object.assign({ style: 'decimal' }, options)
  
  const convertedNumber = (number * fromUnit.multiplier) / toUnit.multiplier
  
  return `${new Intl.NumberFormat(navigatorLanguage, options).format(convertedNumber)} ${toUnit.symbol}`
}

export default Vue.filter('number', numberFilter)
